import React from 'react';
import {Field} from 'formik';
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Constants from "../../../../utils/constants";


function ConteneurDataField({values, errors, handleChange, handleBlur, mode, patrimoines}) {
    return (
        <Grid container size={12} spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Informations Conteneur</Typography>
            </Grid>

            {/* PATRIMOINE */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Patrimoine <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="patrimoine">
                        {({field, form}) => (
                            <FormControl required fullWidth margin="normal" error={Boolean(form.errors.patrimoine && form.touched.patrimoine)}>
                                <InputLabel id="label-patrimoine">Patrimoine</InputLabel>
                                <Select
                                    labelId="label-patrimoine"
                                    label="Patrimoine"
                                    value={values.patrimoine ?? ""}
                                    onChange={(event) => form.setFieldValue("patrimoine", event.target.value)}
                                >
                                    {(patrimoines || []).map((p) => (
                                        <MenuItem key={p.id} value={`/api/patrimoines/${p.id}`}>{p.libelle}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* NOMENCLATURE */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Nomenclature <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="nomenclature">
                        {({field, form}) => (
                            <TextField
                                required
                                error={Boolean(form.errors.nomenclature && form.touched.nomenclature)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.nomenclature}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="nomenclature"
                                label="Nomenclature"
                                helperText={form.errors.nomenclature && form.touched.nomenclature ? form.errors.nomenclature : ""}
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* ADRESSE */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Adresse <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="adresse">
                        {({field, form}) => (
                            <TextField
                                error={Boolean(form.errors.adresse && form.touched.adresse)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.adresse}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="adresse"
                                label="Adresse"
                                helperText={form.errors.adresse && form.touched.adresse ? form.errors.adresse : ""}
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* COMPLEMENT ADRESSE */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Complément d'adresse
                </Grid>
                <Grid size={9}>
                    <Field name="complementAdresse">
                        {({field, form}) => (
                            <TextField
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.complementAdresse}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="complementAdresse"
                                label="Complément d'adresse"
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* COMMUNE */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Commune <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="commune">
                        {({field, form}) => (
                            <TextField
                                required
                                error={Boolean(form.errors.commune && form.touched.commune)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.commune}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="commune"
                                label="Commune"
                                helperText={form.errors.commune && form.touched.commune ? form.errors.commune : ""}
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* LATITUDE */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Latitude <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="latitude">
                        {({field, form}) => (
                            <TextField
                                required
                                error={Boolean(form.errors.latitude && form.touched.latitude)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.latitude}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="latitude"
                                label="Latitude"
                                helperText={form.errors.latitude && form.touched.latitude ? form.errors.latitude : ""}
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* LONGITUDE */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Longitude <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="longitude">
                        {({field, form}) => (
                            <TextField
                                required
                                error={Boolean(form.errors.longitude && form.touched.longitude)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.longitude}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="longitude"
                                label="Longitude"
                                helperText={form.errors.longitude && form.touched.longitude ? form.errors.longitude : ""}
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* TYPE DE CONTENEUR */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Type de conteneur <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="conteneurType">
                        {({field, form}) => (
                            <FormControl required fullWidth margin="normal" error={Boolean(form.errors.conteneurType && form.touched.conteneurType)}>
                                <InputLabel id="label-conteneur-type">Type de conteneur</InputLabel>
                                <Select
                                    labelId="label-conteneur-type"
                                    label="Type de conteneur"
                                    value={values.conteneurType ?? ""}
                                    onChange={(event) => form.setFieldValue("conteneurType", event.target.value)}
                                >
                                    {Constants.CONTENEURS_TYPE.map((t) => (
                                        <MenuItem key={t.code} value={t.code}>{t.libelle}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* TYPE DE DECHET */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Type de déchet <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="dechetType">
                        {({field, form}) => (
                            <FormControl required fullWidth margin="normal" error={Boolean(form.errors.dechetType && form.touched.dechetType)}>
                                <InputLabel id="label-dechet-type">Type de déchet</InputLabel>
                                <Select
                                    labelId="label-dechet-type"
                                    label="Type de déchet"
                                    value={values.dechetType ?? ""}
                                    onChange={(event) => form.setFieldValue("dechetType", event.target.value)}
                                >
                                    {Constants.DECHET_TYPES.map((t) => (
                                        <MenuItem key={t.code} value={t.code}>{t.libelle}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* QUANTITE */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Quantité (nombre de bacs) <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="quantite">
                        {({field, form}) => (
                            <TextField
                                required
                                error={Boolean(form.errors.quantite && form.touched.quantite)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.quantite}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="quantite"
                                label="Quantité"
                                type="number"
                                helperText={form.errors.quantite && form.touched.quantite ? form.errors.quantite : ""}
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* MARQUE */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Marque
                </Grid>
                <Grid size={9}>
                    <Field name="marque">
                        {({field, form}) => (
                            <TextField
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.marque}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="marque"
                                label="Marque"
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default ConteneurDataField;
